import React from "react";
import { ModalType, useModal } from "../../../../Context/ModalContext";


function TextColorSelector() {
  const { toggleShow } = useModal();
  return (
    <div className="toolbar-button"
         onClick={ () => {toggleShow( true, null, ModalType.textColor );} }
         data-test={"text-color"}>
      <i className="fas fa-palette"></i>
    </div>
  );
}

export default TextColorSelector;